import { GrowthCategory, GrowthContent } from '@mc/api'
import { useStaticData } from '@mc/static-data-react'

import { SubcatCourses } from 'components/SubcatCourses'
import { type PrimaryCategoryAndSubcategory } from 'libs/server/api'
import { Course } from 'types/data'

export const SubcatCoursesSection = () => {
  const {
    course,
    classSubcategories,
    primaryGrowthCatAndSubcat,
    otherClassesInSameSubcategories,
  } = useStaticData<{
    course: Course
    classSubcategories: GrowthCategory[]
    primaryGrowthCatAndSubcat: PrimaryCategoryAndSubcategory
    otherClassesInSameSubcategories: GrowthContent[]
  }>()

  return (
    <SubcatCourses
      subcategories={classSubcategories}
      classes={otherClassesInSameSubcategories}
      course={course}
      primaryCategory={primaryGrowthCatAndSubcat.primaryCategory}
    />
  )
}
